
import { Vue, Prop, Component } from "vue-property-decorator";

@Component
export default class SMSPreferences extends Vue {
    @Prop() id!: string;
    @Prop() username!: string;
    @Prop() isUserOptedIn!: boolean;
    @Prop() mobileNumber!: string;
    @Prop() validated!: boolean;
    @Prop() validatedDate!: Date | null;
    @Prop() callBeforeText!: boolean;
    @Prop() callNumber!: string;
    @Prop() activationCode!: string;
    @Prop() activationCodeExpiresUtc!: Date;
    
    @Prop() assignmentCreated!: boolean;
    @Prop() assignmentModified!: boolean;
    @Prop() assignmentCanceled!: boolean;
    @Prop() staffingNeed!: boolean;
    @Prop() staffingNeedCriticalPay!: boolean;
}

